import React from "react";
import { useLiveEdit } from "../../lib/liveEdit";
import { HOME_SECTIONS } from "../../lib/sectionRegistry";
import { ChevronUp, ChevronDown, EyeOff, GripVertical } from "lucide-react";

export default function SectionSlot({ sectionKey, index, total }) {
  const { editMode, isAdmin, hideSection, moveSection } = useLiveEdit();
  const meta = HOME_SECTIONS[sectionKey];
  if (!meta) return null;
  const Cmp = meta.Component;

  const showChip = editMode && isAdmin;

  return (
    <section className="relative group/section" data-section-key={sectionKey} data-testid={`section-${sectionKey}`}>
      {showChip && (
        <div className="pointer-events-none absolute inset-0 z-40 ring-2 ring-yellow-400/0 group-hover/section:ring-yellow-400/60 rounded-lg transition" />
      )}
      {showChip && (
        <div className="pointer-events-auto absolute top-4 right-4 z-50 opacity-0 group-hover/section:opacity-100 focus-within:opacity-100 transition">
          <div className="flex items-center gap-1 rounded-full bg-[#04102e] text-white pl-3 pr-1 py-1 shadow-2xl border border-yellow-400/40" data-testid={`section-controls-${sectionKey}`}>
            <span className="hidden md:inline-flex items-center gap-1 text-[10px] uppercase tracking-widest font-bold text-yellow-300">
              <GripVertical className="h-3 w-3" /> {meta.label}
            </span>
            <button
              type="button"
              onClick={() => moveSection(sectionKey, -1)}
              disabled={index === 0}
              className="h-7 w-7 rounded-full hover:bg-white/10 disabled:opacity-30 flex items-center justify-center"
              title="Move up"
              data-testid={`section-up-${sectionKey}`}
            >
              <ChevronUp className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={() => moveSection(sectionKey, 1)}
              disabled={index === total - 1}
              className="h-7 w-7 rounded-full hover:bg-white/10 disabled:opacity-30 flex items-center justify-center"
              title="Move down"
              data-testid={`section-down-${sectionKey}`}
            >
              <ChevronDown className="h-4 w-4" />
            </button>
            {!meta.locked && (
              <button
                type="button"
                onClick={() => hideSection(sectionKey)}
                className="h-7 px-2 gap-1 rounded-full bg-red-500/90 hover:bg-red-500 text-white text-[11px] font-bold uppercase tracking-wider flex items-center"
                title="Hide section"
                data-testid={`section-hide-${sectionKey}`}
              >
                <EyeOff className="h-3.5 w-3.5" /> Hide
              </button>
            )}
          </div>
        </div>
      )}
      <Cmp />
    </section>
  );
}
